import { render, staticRenderFns } from "./ProjectBriefingDrawer.vue?vue&type=template&id=3d0cbba6&scoped=true&"
import script from "./ProjectBriefingDrawer.vue?vue&type=script&lang=js&"
export * from "./ProjectBriefingDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBriefingDrawer.vue?vue&type=style&index=0&id=3d0cbba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cbba6",
  null
  
)

export default component.exports